import type { SearchScenarioId } from 'owa-search-store';
import { action } from 'satcheljs';
import type SuggestionSet from 'owa-search-service/lib/data/schema/SuggestionSet';

/**
 * Action that the consuming client should dispatch when it wants to set suggestions
 * in the store.
 */
export const setCurrentSuggestions = action(
    'SET_CURRENT_SUGGESTIONS',
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (14,66): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    (suggestionSet: SuggestionSet, scenarioId: SearchScenarioId, qfRequestId: string = null) => ({
        suggestionSet,
        scenarioId,
        qfRequestId,
    })
);
